import type { Action, Dispatch } from 'redux';
import { dismissModal } from '../actions/feedback.actions';
import { logoutApp } from '../actions/login.action';

/** Log out after heartbeat 401 when FRONTEND_SESSION_FIRST is enabled. */
export function dispatchSessionHeartbeatMiss(dispatch: Dispatch) {
  dispatch(dismissModal() as Action);
  dispatch((logoutApp({ showModal: false }) as any) as Action);
}
